import {Component, computed, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {BadgeModule} from 'primeng/badge';
import {NonHrSystems, DirectusTranslation} from '@frontend/directus';
import {Tooltip} from 'primeng/tooltip';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {ModuleNonHrIntegrationSystemRecording} from '@frontend/shared';

@Component({
  selector: 'app-non-hr-system-recording-card',
  imports: [TranslocoPipe, BadgeModule, Tooltip, TranslateDirectusPipe],
  templateUrl: './non-hr-system-recording-card.component.html',
})
export class NonHrSystemRecordingCardComponent {
  readonly nonHrSystems = input.required<NonHrSystems[]>();
  readonly moduleNonHrSystemRecording = input.required<ModuleNonHrIntegrationSystemRecording>();
  readonly centered = input<boolean>(false);

  protected readonly moduleFunctionSystemRecordings = computed(
    () => this.moduleNonHrSystemRecording().moduleFunctionSystemRecordings,
  );

  protected readonly moduleFunctionsCount = computed(
    () => this.moduleFunctionSystemRecordings().length,
  );

  protected moduleFunctionTranslations(systemDirectusUuid: string): DirectusTranslation[] {
    const current = this.nonHrSystems();
    return current.find((system) => system.id === systemDirectusUuid)?.translations ?? [];
  }
}
